import * as API from '../api'

export const FETCH_PRODUCT = 'FETCH_PRODUCT'
export const FETCH_PRODUCT_ERROR = 'FETCH_PRODUCT_ERROR'
export const FETCH_PRODUCTS = 'FETCH_PRODUCTS'
export const FETCH_PRODUCTS_ERROR = 'FETCH_PRODUCTS_ERROR'
export const FETCHING_PRODUCT = 'FETCHING_PRODUCT'
export const FETCHING_PRODUCTS = 'FETCHING_PRODUCTS'

export const fetchProducts = areaId => {
  return dispatch => {
    dispatch({ type: FETCHING_PRODUCTS, value: true })

    return API.controlledProducts
      .getProducts(areaId)
      .then(response => {
        dispatch({
          type: FETCH_PRODUCTS,
          last_update: (response.data || {}).last_update,
          items: (response.data || {}).items
        })
      })
      .catch(err => {
        dispatch({ type: FETCH_PRODUCTS_ERROR })
      })
  }
}

export const fetchProduct = (areaId, id) => {
  return dispatch => {
    dispatch({ type: FETCHING_PRODUCT, value: true })

    return API.controlledProducts
      .getProduct(areaId, id)
      .then(response => {
        const data = response.data
        dispatch({ type: FETCH_PRODUCT, product: data })
      })
      .catch(err => {
        dispatch({ type: FETCH_PRODUCT_ERROR })
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/controlledProducts.js